// @ts-check

import { Component } from '@verndale/core';
import { rovingIndex } from '@verndale/roving-ux';
import { OPEN_CART_EVENT } from '../components/cart-modal';
import { setTrackDataLayer } from '../utils';

class Module extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    const { showVideo } = this.el.dataset;
    const { privatePrice } = this.el.dataset;

    this.dom = {};

    if (showVideo) {
      this.dom = {
        $tabs: this.el.querySelectorAll('.tabbed-content__tab'),
        $tabContainer: this.el.querySelector('.tabbed-content__tabs-list'),
        $tabPanels: this.el.querySelectorAll('.tabbed-content__tabpanel'),
        $select: this.el.querySelector('.tabbed-content__tabs-select'),
        $selectOptions: this.el
          .querySelector('.tabbed-content__tabs-select')
          .querySelectorAll('option'),
        productKeyInput: this.el.querySelector('#productKey'),
        sitecoreIdInput: this.el.querySelector('#sitecoreId'),
        quantityInput: this.el.querySelector('#quantity'),
        addToCartButton: this.el.querySelector('#addToCart')
      };

      // Activate the first tab
      this.activateTab(this.dom.$tabs[0].id);
    }

    this.dom.productKeyInput = this.el.querySelector('#productKey');
    this.dom.sitecoreIdInput = this.el.querySelector('#sitecoreId');
    this.dom.quantityInput = this.el.querySelector('#quantity');

    if (!privatePrice) {
      this.dom.addToCartButton = this.el.querySelector('#addToCart');
    }

    this.cartEndpoint = this.el.dataset.cartEndpointUrl;
  }

  addListeners() {
    const { showVideo } = this.el.dataset;
    const { privatePrice } = this.el.dataset;

    if (showVideo) {
      this.dom.$tabs.forEach((tab) =>
        tab.addEventListener('click', (e) => {
          this.activateTab(e.currentTarget.id);
        })
      );

      this.dom.$select.addEventListener('change', (e) => {
        this.activateTab(e.target.value);
      });
    }

    if (!privatePrice) {
      this.dom.addToCartButton.addEventListener(
        'click',
        this.handleSubmit.bind(this)
      );
    }

    if (this.dom.quantityInput) {
      this.dom.quantityInput.addEventListener(
        'keydown',
        this.handleNumericInput.bind(this)
      );
    }
  }

  activateTab(tabID) {
    const activeTab = [...this.dom.$tabs].find((tab) => tab.id === tabID);
    const controls = activeTab.getAttribute('aria-controls');

    [...this.dom.$selectOptions].forEach((option) => {
      if (option.value === tabID) {
        option.selected = true;
      }
    });

    // Deactivate all other tabs
    this.deactivateTabs();

    activeTab.setAttribute('aria-selected', true);

    const activePanel = [...this.dom.$tabPanels].find(
      (panel) => panel.id === controls
    );

    activePanel.hidden = false;

    this.setRovings();
  }

  deactivateTabs() {
    this.dom.$tabs.forEach((tab) => tab.setAttribute('aria-selected', false));

    this.dom.$tabPanels.forEach((panel) => {
      panel.hidden = true;
    });
  }

  setRovings() {
    rovingIndex({
      element: this.dom.$tabContainer,
      target: '.tabbed-content__tab',
      callback: (el) => {
        this.activateTab(el.id);
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const SitecoreId = this.dom.sitecoreIdInput.value;
    const ProductKey = this.dom.productKeyInput.value;
    const Quantity = this.dom.quantityInput.value;
    const {
      itemName,
      itemId,
      itemPrice,
      itemCategory,
      itemCategory2,
      itemCategory3,
      itemCategory4,
      itemCategory5,
      itemBrand
    } = this.el.dataset;

    const currentURL = window.location.href;
    const listNameSufix = currentURL.split('/').pop();

    const productInfo = {
      item_name: itemName,
      item_id: itemId,
      price: Number(itemPrice),
      item_category: itemCategory,
      item_category2: itemCategory2,
      item_category3: itemCategory3,
      item_category4: itemCategory4,
      item_category5: itemCategory5,
      item_brand: itemBrand,
      list_id: 'product-detail-page',
      list_name: `product-detail-page-${listNameSufix}`,
      quantity: Number(Quantity)
    };

    fetch(this.cartEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        SitecoreId,
        ProductKey,
        Quantity
      })
    })
      .then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.dispatchEvent(new Event(OPEN_CART_EVENT));
        setTrackDataLayer({
          eventName: 'add_to_cart',
          custom: {
            ecommerce: {
              items: [productInfo]
            }
          }
        });
      })
      .catch(console.error);
  }

  handleNumericInput(e) {
    const filter = ['.', ',', 'e', 'E'];
    const { key } = e;
    if (filter.includes(key)) {
      e.preventDefault();
    }
  }
}

export default Module;
